
















































import Vue from 'vue'

import AppForm from '@/components/app/AppForm.vue'
import CameraSystem from '@/pages/CameraSystem.vue'
import ResourceCreate from '@/pages/ResourceCreate.vue'
import ScheduleEditor from '@/components/ScheduleEditor.vue'

export default Vue.extend({
  name: "ResourceSingle",
  components: { AppForm, CameraSystem, ResourceCreate, ScheduleEditor },
  props: {
    id: {
      type: String,
      default: null
    },
    resource: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      createRelated: {
        resource: null
      },
      fields: [] as FormField[],
      loading: false,
      relatable: {},
      values: {}
    }
  },
  
  methods: {
    createdRelated(result) {
      this.fields[this.fields.findIndex(field => field.key == result.resource)].value.push(result.id)
      this.relatable[result.resource].push(result.data)
      this.createRelated.resource = null
    },
    showCreateRelated(resource) {
      this.createRelated.resource = resource
    },

    async update(newValues) {
      this.loading = true
      
      const data = {}
      this.fields.forEach(field => {
        if (newValues[field.key] !== undefined || this.values[field.key] !== undefined) {
          const oldValue = this.values[field.key] //!== undefined ? this.values[field.key] : field.defaultValue
          const oldValueNotUndefined = this.values[field.key] !== undefined ? this.values[field.key] : field.defaultValue
          const newValue = newValues[field.key] !== undefined ? newValues[field.key] : field.defaultValue          
          if (JSON.stringify(oldValue) != JSON.stringify(newValue) && newValue !== undefined) {       
            data[field.key] = {old: oldValueNotUndefined, new: newValue}
          }
        }
      })

      if (Object.keys(data).length) {
        try {
          const result = await this.$api.update(this.resource, this.id, data)
          alert(result.message)
          this.initData()
        } catch (error) {
          window.console.error(error)
        }
      } else {
        alert("No values changed.")
      }

      this.loading = false
    },

    async initData() {
      const doc = this.$db.collection(this.resource).doc(this.id).get().then(async doc => {
        if (doc.exists) {
          const values = doc.data() || {}
          const schema = await this.$schema.get(this.resource)
          const fields = [] as any[]
          schema.forEach(field => {
            if (
              (field.display === 'field' 
              || (field.display === 'meta' && this.$store.state.auth.token.claims.super)
              || (field.display === 'relationship' && this.$store.state.auth.token.claims.permissions.indexOf(`update:${field.key}`) > -1))
              || this.$store.state.auth.token.claims.permissions.indexOf(`update:super`) > -1
            ) {
              const value = values[field.key] !== undefined ? JSON.parse(JSON.stringify(values[field.key])) : undefined
              fields.push( Object.assign(field, { value }))
              this.$set(this.values, field.key, values[field.key] !== undefined ? JSON.parse(JSON.stringify(values[field.key])) : undefined)
            }
          })

          this.fields = fields
          fields.filter(field => {
            return field.display === "relationship"
          }).forEach(field => {
            if(this.$_data[field.key]) this.$set(this.relatable, field.key, this.$_data[field.key].data)
          })
        } else {
          throw {
            code: "document/not-found",
            message: `${this.resource} document with ID: ${this.id} does not exist.`,
            status: 404
          }
        }
      }).catch(err => {
        this.$router.push(`/${this.resource}`)
        window.console.log(err)
        alert(err.message)
      })
    }
  },

  async created() {
    this.initData()
  }
})
